import { computed } from 'mobx';

export default class SystemModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = item.id;
    this.app_title = item.app_title;
    this.organization_name = item.organization_name;
    this.app_version = item.app_version;
    this.db_host = item.db_host;
    this.db_port = item.db_port;
    this.db_user = item.db_user;
    this.db_password = item.db_password;
    this.db_name = item.db_name;
  }

  @computed get asJson() {
    return {
      id: this.id,
      app_title: this.app_title,
      organization_name: this.organization_name,
      app_version: this.captioapp_version,
      db_host: this.descriptiodb_host,
      db_port: this.sedb_port,
      db_user: this.sedb_user,
      db_password: this.sedb_password,
      db_name: this.sedb_name,
    };
  }

  updateFromJson(json) {
    this.id = json.id;
    this.app_title = json.app_title;
    this.organization_name = json.organization_name;
    this.app_version = json.app_version;
    this.db_host = json.db_host;
    this.db_port = json.db_port;
    this.db_user = json.db_user;
    this.db_password = json.db_password;
    this.db_name = json.db_name;
  }
}



// WEBPACK FOOTER //
// ./src/models/SystemConfiguration/SystemModel.js